// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mVwA","left":"styles_left__15FJG"};